// this file contains only services used in the standalone embedded order form
// do not use it in regular build, as the module registration is already done within the services.js
import { registerServiceModule } from '@/genericStoreService'

import grpcCustomer from '@/proto/customer/customer_grpc_web_pb'
import grpcCommon from '@/proto/common/common_pb'

export default store => {
  registerServiceModule(store, {
    name: 'miniShop',
    service: {
      import: grpcCustomer,
      address: process.env.VUE_APP_API_URL,
      paginationObjectType: null,
      typeImports: [grpcCommon, grpcCustomer],
      typeMappings: {
        'invoiceAddress': 'Address',
        'deliveryAddress': 'Address'
      }
    },
    manualActions: true,
    actions: {
      trigger: {
        getMiniShop: {},
        createMiniShopOrder: {},
        captureMiniShopOrder: {},
        validateMiniShopOrder: {},
        error: {}
      }
    },
    hooks: {
      autoLoad: async ({ dispatch }) => {
        dispatch('ui/preload', null, { root: true })
      }
    }
  })
}
